/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  isLogin: false,
  data: {},
  error: null,
  loading: false,
};
